<template>
  <v-container :class="{ 'pt-12': $vuetify.breakpoint.lgAndUp }">
    <loading-spinner v-if="loading"> </loading-spinner>
    <profile-form
      v-else-if="!profile.statusId"
      register
      title="Create account"
      subtitle=""
      saveAction="profile/saveRegisterProfile"
    ></profile-form>
    <loading-spinner v-else-if="profile.initialSurveyUrl"> </loading-spinner>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import ProfileForm from "@/components/profile/ProfileForm";
export default {
  name: "Register",
  components: {
    ProfileForm
  },
  data: () => ({ loading: false }),
  computed: mapGetters({ profile: "profile/profile" }),
  created() {
    this.loading = true;
    this.$store
      .dispatch("profile/getRegisterProfile", this.$route.params.id)
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>
